import { render } from "./SessionEditComponent.vue?vue&type=template&id=124cd11c&ts=true"
import script from "./SessionEditComponent.vue?vue&type=script&lang=ts"
export * from "./SessionEditComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__